import { useMemo } from 'react';
import { GeneralCatalogItem } from 'data-layer-cr/dist/models';
import { DisplayItem } from 'design-system';
import { useNetworkObserver } from 'data-layer-cr/dist/network';
// functions
import { mapCatatalogToDisplay as mapToDisplay } from 'src/functions/mapCatatalogToDisplay';
import { BENEFICIARY_OCCUPATIONS_REQUEST } from 'src/store/legalEntityCatalog/actions/legalEntityRequestIdentifiers';
// store

type Props = {
  beneficiaryOccupations: GeneralCatalogItem[];
};

type HookResult = {
  requestingBeneficiaryOccupations: boolean;
  beneficiaryOccupationOptions: DisplayItem[];
};

/**
 * Returns external parameters provided by the old link
 */
export default function useOccupationInformation({
  beneficiaryOccupations,
}: Props): HookResult {
  const beneficiaryOccupationsRequestStatus = useNetworkObserver(
    BENEFICIARY_OCCUPATIONS_REQUEST,
  );

  const beneficiaryOccupationOptions = useMemo(
    () => mapToDisplay(beneficiaryOccupations),
    [beneficiaryOccupations],
  );

  return {
    requestingBeneficiaryOccupations:
      beneficiaryOccupationsRequestStatus === 'requesting',
    beneficiaryOccupationOptions,
  };
}
